import { TFileTypes } from '@interfaces/import/import';

import { EFileExtensions, EMIMETypes } from '@enums/common';
import { EDropzoneFileErrorCodes } from '@enums/dropzone';

import { MEGA_BYTE } from '@constants/common';

export const acceptedFileTypes: TFileTypes = {
	[EMIMETypes.png]: [EFileExtensions.png],
	[EMIMETypes.doc]: [EFileExtensions.doc],
	[EMIMETypes.docx]: [EFileExtensions.docx],
	[EMIMETypes.xls]: [EFileExtensions.xls],
	[EMIMETypes.xlsx]: [EFileExtensions.xlsx],
	[EMIMETypes.txt]: [EFileExtensions.txt],
	[EMIMETypes.ppt]: [EFileExtensions.ppt],
	[EMIMETypes.pptx]: [EFileExtensions.pptx],
	[EMIMETypes.jpeg]: [EFileExtensions.jpeg, EFileExtensions.jpg],
	[EMIMETypes.pdf]: [EFileExtensions.pdf],
};

const MAX_MEGA_BYTES = 10;

export const MAX_BYTES = MAX_MEGA_BYTES * MEGA_BYTE;

export const fileErrors = {
	[EDropzoneFileErrorCodes.fileInvalidType]: 'Extension is not supported. Supports: DOC, DOCX, XLS, XLSX, TXT, PPT, PPTX, JPG, PNG, PDF',
	[EDropzoneFileErrorCodes.fileTooLarge]: `The file size must be less than ${MAX_MEGA_BYTES}MB`,
};

export const supportsText = 'Supports: DOC, DOCX, XLS, XLSX, TXT, PPT, PPTX, JPG, PNG, PDF';
